let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Wx8B")).then(() => parcelRequire('7icLO'));